/**
 * English name for an ISO 3166-1 alpha-2 code, as stored on analytics events
 * (backend services/analytics-geo.js: ip_country, device_region). Falls back to
 * the code itself when the browser has no Intl.DisplayNames or the code is unknown.
 */
// Intl.DisplayNames is newer than this project's TypeScript lib (es2017).
const DisplayNames = (Intl as any).DisplayNames;
const regionNames = DisplayNames ? new DisplayNames(['en'], { type: 'region' }) : null;

export function countryName(code: string | null | undefined): string | null {
    if (!code) return null;
    try {
        return regionNames?.of(code) || code;
    } catch {
        return code;
    }
}
